<template>
  <div class="flex flex-wrap gap-12">
    <RevButton
      v-if="actions.isSendMessageAllowed"
      data-qa="message-bar-answer-button"
      :disabled="actions.isSendMessageDisabled"
      size="small"
      variant="secondary"
      @click="handleSendMessage"
    >
      {{ i18n(translations.sendMessage) }}
    </RevButton>

    <RevButton
      v-if="actions.isReplyToAgentAllowed"
      :disabled="actions.isSendMessageDisabled"
      size="small"
      variant="secondary"
      @click="handleReplyToAgent"
    >
      {{ i18n(translations.replyToAgent) }}
    </RevButton>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'

import type { Actions, MachineSend } from '../../../../ActionBar.machine.type'

import translations from './SecondaryActions.translations'

const props = defineProps<{
  actions: Actions
  send: MachineSend
}>()

const i18n = useI18n()

function handleSendMessage() {
  props.send('START_SEND_MESSAGE_FLOW')
}

function handleReplyToAgent() {
  props.send('START_SEND_MESSAGE_FLOW')
}
</script>
